import React, { useState, useEffect } from 'react';
import './MobileNavigation.css';

interface MobileNavigationProps {
  currentView: 'map' | 'conversations' | 'profile';
  onViewChange: (view: 'map' | 'conversations' | 'profile') => void;
  unreadCount?: number;
  className?: string;
}

const MobileNavigation: React.FC<MobileNavigationProps> = ({
  currentView,
  onViewChange,
  unreadCount = 0,
  className = ''
}) => {
  const [isVisible, setIsVisible] = useState(true);
  const [lastScrollY, setLastScrollY] = useState(0);

  // Auto-hide navigation on scroll down, show on scroll up
  useEffect(() => {
    const handleScroll = () => {
      const currentScrollY = window.scrollY;
      
      if (currentScrollY > lastScrollY && currentScrollY > 100) {
        setIsVisible(false);
      } else {
        setIsVisible(true);
      }
      
      setLastScrollY(currentScrollY);
    };

    window.addEventListener('scroll', handleScroll, { passive: true });
    return () => window.removeEventListener('scroll', handleScroll);
  }, [lastScrollY]);

  const navigationItems = [
    {
      id: 'map' as const,
      label: 'Map',
      icon: '🗺️',
      ariaLabel: 'View map'
    },
    {
      id: 'conversations' as const,
      label: 'Chats',
      icon: '💬',
      ariaLabel: 'View conversations',
      badge: unreadCount > 0 ? unreadCount : undefined
    },
    {
      id: 'profile' as const,
      label: 'Profile',
      icon: '👤',
      ariaLabel: 'View profile'
    }
  ];

  return (
    <nav 
      className={`mobile-navigation ${isVisible ? 'visible' : 'hidden'} ${className}`}
      role="navigation"
      aria-label="Main navigation"
    >
      <div className="mobile-nav-container">
        {navigationItems.map((item) => (
          <button
            key={item.id}
            className={`mobile-nav-item ${currentView === item.id ? 'active' : ''}`}
            onClick={() => onViewChange(item.id)}
            aria-label={item.ariaLabel}
            aria-current={currentView === item.id ? 'page' : undefined}
          >
            <div className="mobile-nav-icon">
              {item.icon}
              {item.badge && (
                <span className="mobile-nav-badge" aria-label={`${item.badge} unread messages`}>
                  {item.badge > 99 ? '99+' : item.badge}
                </span>
              )}
            </div>
            <span className="mobile-nav-label">{item.label}</span>
          </button>
        ))}
      </div>
    </nav>
  );
};

export default MobileNavigation;